// extracted by mini-css-extract-plugin
module.exports = {"footerdiv":"footerbar_footerdiv__30LB1"};